import styled from "styled-components";
import tw from "twin.macro";
import { Theme } from "../../context";

export const ImageContainer = styled.div`
  ${tw`flex items-center justify-center py-5`}
`;

export const JiffyButtonContainer = styled.div`
  ${tw`flex items-center justify-center py-5`}
`;

export const ListWrapper = styled.div<{ rooTheme?: Theme }>`
  ${tw`flex items-center justify-between w-full lg:my-6 lg:mt-20 lg:px-20`}
  display: flex;

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ListContainer = styled.div<{ rooTheme?: Theme }>`
  ${tw`flex-col items-center justify-center w-[90%] lg:w-[31%] px-4 py-12 lg:mt-0 mt-4 text-center rounded-3xl justify-items-center`}
  ${({ rooTheme }) =>
    rooTheme === "dark"
      ? tw`bg-[rgba(0, 0, 0, 0.05)]`
      : tw`bg-[rgba(255, 255, 255, 0.05)]`};
  ${({ rooTheme }) =>
    rooTheme !== "dark"
      ? tw`border border-[rgba(0, 0, 0, 0.05)]`
      : tw`border border-[rgba(0, 127, 255, 0.4)]`};

  @media screen and (max-width: 768px) {
    width: 90%;
  }
`;

export const ListText = styled.p<{ rooTheme?: Theme }>`
  ${tw`text-base not-italic font-semibold leading-5 font-clash`}
  ${({ rooTheme }) =>
    rooTheme === "dark" ? tw`text-white` : tw`text-heroColor`};
`;

export const ListDescription = styled.p<{ rooTheme?: Theme }>`
  ${tw`text-sm not-italic font-normal font-clash`}
  ${({ rooTheme }) =>
    rooTheme === "dark" ? tw`text-white` : tw`text-heroColor`};
`;

export const ListImageContainer = styled.div<{ rooTheme?: Theme }>`
  ${tw`flex items-center justify-center w-10 h-10 mx-auto my-4 rounded-full`}
  ${({ rooTheme }) => (rooTheme === "dark" ? tw`bg-white` : tw`bg-heroColor`)};
`;
